import * as React from "react";
import { HTMLTable } from "@blueprintjs/core";
import { schemeGnBu } from "../../utils/colours";

const EC_TYPES = [
  { color: schemeGnBu[1], text: "EC1 Oxidoreductases" },
  { color: schemeGnBu[2], text: "EC2 Transferases" },
  { color: schemeGnBu[3], text: "EC3 Hydrolases" },
  { color: schemeGnBu[4], text: "EC4 Lyases" },
  { color: schemeGnBu[5], text: "EC5 Isomerases" },
  { color: schemeGnBu[6], text: "EC6 Ligases" },
  { color: schemeGnBu[7], text: "EC7 Translocases" },
  { color: "dimgray", text: "All Other CDS" },
  { color: "lightgray", text: "Hypothetical Proteins" },
  { color: "firebrick", text: "tRNAs" },
  { color: "#fce205", text: "AMR Gene" },
];

const AnnotationTrackLegend = () => {
  return (
    <HTMLTable bordered={false} interactive={false} className="legend-table">
      <tbody>
        {EC_TYPES.map((ec) => {
          return (
            <tr key={ec.color}>
              <td className="legend-table-element">
                <div
                  className="legend-inner"
                  style={{
                    backgroundColor: ec.color,
                  }}
                />
              </td>
              <td className="legend-table-element">{ec.text}</td>
            </tr>
          );
        })}
      </tbody>
    </HTMLTable>
  );
};

export default AnnotationTrackLegend;
